var _excluded = ["children"];

var _templateObject;

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: 1fr;\n  row-gap: 20px;\n\n  max-width: 250px;\n  margin-left: auto;\n  margin-right: auto;\n\n  @media (min-width: 768px) {\n    max-width: unset;\n    grid-template-columns: repeat(auto-fit, var(--option-card-size, 270px));\n    justify-content: center;\n\n    column-gap: var(--option-gutter-x, 25px);\n  }\n"])));

function PaymentOptionContainer(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Wrapper, props, children);
}

PaymentOptionContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default PaymentOptionContainer;